export interface WebhookPayload {
    answers: { [key: string]: string };
    phone: string;
    timestamp: string;
}

export const sendToWebhook = async (payload: WebhookPayload): Promise<void> => {
    try {
        const response = await fetch(
            'https://n8n.khanes.app/webhook/715a09e5-3830-456c-88e3-76de6be0a69c',
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload),
            },
        );

        if (!response.ok) {
            throw new Error('Failed to send data to the webhook');
        }
    } catch (error) {
        console.error('Error sending data to webhook:', error);
    }
};
